import React from "react";
import styles from "./ProjectList.module.scss";
import ProjectInfoCardView from "../ProjectInfoCardView/ProjectInfoCardView";
import Loader from "../../../../components/atoms/Loader/Loader";
import CompasIcon from "./assets/compas.svg";
export interface ProjectItem {
  title?: string;
  description?: string;
  onClick?: () => void;
  linkTo?: string;
  project_status?: string;
}
export interface ProjectItemProps {
  projectList: ProjectItem[];
  isLoading?: boolean;
  scrollable?: boolean;

}
export default function ProjectList({
  projectList = [],
  isLoading,
  scrollable = false,

}: ProjectItemProps) {
  if (isLoading)
    return (
      <div className={styles["screen"]}>
        <Loader />
      </div>
    );
  if (!projectList.length) return <div className={styles["screen"]}>
    <img className={styles["screen__icon"]}src={CompasIcon} alt="Compas" />
    <p>Aucun projet trouvé</p>
    </div>;
  return (
    <ul className={[styles["project-list"], scrollable ? styles["project-list--scrollable"] : ""].join(" ")}>
      {projectList.map((project, index) => (
        <li key={index} className={styles["project-list--item"]}>
          <ProjectInfoCardView
          maxCharDescription={80}
            maxWidth="500px"
            title={project.title}
            description={project.description}
            onClick={project.onClick}
            linkTo={project.linkTo}
            project_status={project.project_status}
          />
        </li>
      ))}
    </ul>
  );
}
